import Box from '@mui/material/Box';
import NewWindowBlack from 'assets/icons/NewWindowBlack.svg?react';

type ClickableLinkProps = {
  value: string;
  label?: string;
  name?: string;
};

const ClickableLink = (props: ClickableLinkProps) => {
  const { value, label, name } = props;
  const textToRender = label ? label : name;

  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={() => window.open(value, '_blank')}
    >
      <Box
        style={{
          display: 'grid',
          paddingRight: '0.5em',
        }}
      >
        {textToRender}
      </Box>
      <Box>
        <NewWindowBlack />
      </Box>
    </Box>
  );
};

export default ClickableLink;
